import account from './account/en-US.json';
import affiliate from './affiliate/en-US.json';
import component from './component/en-US.json';
import menus from './menus/en-US.json';
import user from './users/en-US.json';
import global from './global/en-US.json';
import support from './support/en-US.json';
import result from './result/en-US.json';
import finance from './finance/en-US.json';
import region from './region/en-US.json';
import request from './request/en-US.json';
// 因不知名原因，当存在menu和user文件夹时，i18n-ally插件没反应，故修改文件名为menus,users

const titleMenu = Object.entries(menus).reduce((pre: object, [key, value]: [string, string]) => {
  // 添加统一后缀
  return {
    ...pre,
    [`title.${key}`]: `${value} - LightNode`,
  };
}, {});

export default {
  ...account,
  ...affiliate,
  ...component,
  ...menus,
  ...titleMenu,
  ...user,
  ...global,
  ...support,
  ...result,
  ...finance,
  ...region,
  ...request,
};
